"use strict";var n=6e4,i=36e5,s=1e3,e=60;exports.millisecondsInHour=i;exports.millisecondsInMinute=n;exports.millisecondsInSecond=s;exports.minutesInHour=e;
